const marginScrollDignity = 600;

window.addEventListener('DOMContentLoaded', () => {
  init();
});

const init = () => {
  console.log('Initialisation');

  mepGallerie();

  var swiper = new Swiper(".index-swiper", {
    loop: true,
    autoplay: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  window.addEventListener('scroll', (e) => windowsScroll(e));
  soutienSectionScroll();
  partsSectionScroll();

}

const windowsScroll = (e) => {
  soutienSectionScroll();
  partsSectionScroll();
}

const soutienSectionScroll = () => {
  const elms = document.querySelectorAll('main.soutien > section');
  elms.forEach(elm => {
    if (elm.getBoundingClientRect().top - marginScrollDignity > 0) {
      elm.classList.remove('appear')
    } else {
      elm.classList.add('appear');
    }
  });
}

const partsSectionScroll = () => {
  const elms = document.querySelectorAll('main.parts > section');
  elms.forEach(elm => {
    if (elm.getBoundingClientRect().top - marginScrollDignity > 0) {
      elm.classList.remove('appear')
    } else {
      elm.classList.add('appear');
    }
  });
}


const mepGallerie = () => {
  const container = document.querySelectorAll('.kg-gallery-card');
  container.forEach(c => {
    const imgs = c.querySelectorAll('.kg-gallery-image');
    const divGallerie = document.createElement('div');
    divGallerie.classList.add('dignity-gallery');
    divGallerie.append(...imgs);
    c.removeChild(document.querySelector('.kg-gallery-container'));
    c.append(divGallerie);
  });
}

const filterProjets = (num) => {
  switch (num) {
    case 0:
      document.querySelectorAll('.projets-list .projet-post').forEach(elm => {
        elm.classList.remove('is-hidden');
        elm.classList.add('is-visible');
      }); 
      break;
      case 1:
      document.querySelectorAll('.projets-list .projet-post:not(.assistance-scolaire)').forEach(elm => {
        elm.classList.add('is-hidden');
        elm.classList.remove('is-visible');
      });
      document.querySelectorAll('.projets-list .projet-post.assistance-scolaire').forEach(elm => {
        elm.classList.remove('is-hidden');
        elm.classList.add('is-visible');
      }); 
      break;
      case 2:
      document.querySelectorAll('.projets-list .projet-post:not(.developpement-durable)').forEach(elm => {
        elm.classList.add('is-hidden');
        elm.classList.remove('is-visible');
      });
      document.querySelectorAll('.projets-list .projet-post.developpement-durable').forEach(elm => {
        elm.classList.remove('is-hidden');
        elm.classList.add('is-visible');
      }); 
      break;
      case 3:
      document.querySelectorAll('.projets-list .projet-post:not(.social)').forEach(elm => {
        elm.classList.add('is-hidden');
        elm.classList.remove('is-visible');
      });
      document.querySelectorAll('.projets-list .projet-post.social').forEach(elm => {
        elm.classList.remove('is-hidden');
        elm.classList.add('is-visible');
      }); 
      break;
  
    default:
      break;
  }
}